import React from 'react';
import html from 'remark-html';
import markdown from 'remark-parse';
import PropTypes from 'prop-types';
import unified from 'unified';

// Components
import Image from '../../Image/Image';
import Link from '../../Link/Link';

// Utils
import generateCategoryColor from '../../../utils/generateCategoryColor';
import calculateReadingTime from '../../../utils/calculateReadingTime';

// Style
import './post-list-item.scss';

const PostListItem = ({ post }) => {
  const { slug, title, featuredImage, content, excerpt, categoryName, categorySlug } = post;

  return (
    <Link
      href={`/blog/${slug}`}
      className="col-lg-2 col-md-3 col-sm-3 col-xs-6"
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
    >
      <div className="flex flex-start" itemProp="item">
        <div className="post-card">
          <div className="post-card-top mb-1">
            <Image
              img={featuredImage}
              alt={title}
              radius={20}
              height="200px"
              customClass="post-card-image-area"
              itemProp="image"
            />
            <div className="reading-time flex flex-center flex-middle text-bold">
              {calculateReadingTime(content)}
            </div>
          </div>
          <div className="post-card-tag-area mb-1">
            <Link
              rel="noreferrer"
              title={title}
              href={`/blog/tags/${categorySlug}`}
              style={{
                color: generateCategoryColor(categorySlug),
              }}
              className="text-uppercase text-bold"
            >
              {categoryName}
            </Link>
          </div>
          <h5 className="post-card-title" itemProp="name">
            {title}
          </h5>
          <div
            className="post-card-excerpt"
            itemProp="description"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: unified()
                .use(markdown)
                .use(html)
                .processSync(`${excerpt.slice(0, 98)}...`),
            }}
          />
        </div>
      </div>
    </Link>
  );
};

PostListItem.propTypes = {
  post: PropTypes.object.isRequired, // eslint-disable-line
};

export default PostListItem;
